const prefix = "admin-date-form";
const ids = {
  calendarType: "calendar-type",
  description: "description",
  periodEnd: "period-end",
  periodStart: "period-start",
  formsCloseDate: "forms-close-date",
  formsOpenDate: "forms-open-date",
  label: "label",
  period: "period",
  year: "year",
};

const names = {
  [ids.calendarType]: "calendarType",
  [ids.description]: "description",
  [ids.periodEnd]: "end",
  [ids.periodStart]: "start",
  [ids.formsCloseDate]: "formsCloseDate",
  [ids.formsOpenDate]: "formsOpenDate",
  [ids.label]: "label",
  [ids.period]: "period",
  [ids.year]: "year",
};

const fields = {
  editable: [
    ids.description,
    ids.periodEnd,
    ids.periodStart,
    ids.formsCloseDate,
    ids.formsOpenDate,
    ids.label,
  ],
  create: [
    ids.calendarType,
    ids.description,
    ids.periodEnd,
    ids.periodStart,
    ids.formsCloseDate,
    ids.formsOpenDate,
    ids.label,
    ids.period,
    ids.year,
  ]
}

const labels = {
  [ids.calendarType]: "Session Type",
  [ids.description]: "Description",
  [ids.periodEnd]: "End",
  [ids.periodStart]: "Start",
  [ids.formsCloseDate]: "Forms Close Date",
  [ids.formsOpenDate]: "Forms Open Date",
  [ids.label]: "Label",
  [ids.period]: "Period",
  [ids.year]: "Year",
}

export const formConstants = {
  prefix,
  ids,
  names,
  fields,
  labels
};
